import { fetchAll, fetchFiltered, show, add, edit } from '@/api/systemModules'

const state = {
  all: [],
  isLoading: false,
  systemModuleById: null
}

const getters = {}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const systemModules = await fetchAll()
      commit('setAll', systemModules)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const systemModule = await show(id)
      commit('setSystemModuleById', systemModule)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const systemModules = await fetchFiltered(queriesParams)
      commit('setAll', systemModules)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await add(data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  setAll (state, systemModules) {
    state.all = systemModules
  },

  setSystemModuleById (state, systemModule) {
    const { id, name, tag, active } = systemModule
    state.systemModuleById = { id, name, tag, active }
  },

  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.systemModuleById = null
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
